module.exports = __WEBPACK_EXTERNAL_MODULE__egovernments_digit_ui_svg_components__;